import { useContext } from "react";
import { PageNewState, PartnerDetailPageContext } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(PartnerDetailPageContext);

  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
